<div class="form-header">
    <h3 class="title">
      {{ 'SERVICE_PROVIDERS.INTAKE_ASSESSMENT_FORM.TITLE' | translate }}
    </h3>
</div>
<mat-vertical-stepper #stepper [linear]="!firstStep.valid" class="stepper">
    <mat-step [stepControl]="firstStep">
      <form class="form" [formGroup]="firstStep">
        <ng-template matStepLabel>
            {{ 'SERVICE_PROVIDERS.ASSESSMENT_FORM.STEP_01.TITLE' | translate }}
        </ng-template>
        <field-holder kind="2-cols">
          <mat-form-field appearance="outline">
            <mat-label>
              {{ 'SERVICE_PROVIDERS.INTAKE_ASSESSMENT_FORM.STEP_01.DATE' | translate }}
            </mat-label>
            <input matInput [matDatepicker]="picker" formControlName="dateOfSubmission" readonly required disabled
              autocomplete="off" [max]="maxDate" />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>
              {{ 'SERVICE_PROVIDERS.ASSESSMENT_FORM.STEP_01.SERVICE_PROVIDER' | translate }}
            </mat-label>
            <input matInput type="text" formControlName="serviceProvider" required readonly autocomplete="off" />
          </mat-form-field>
        </field-holder>
        <field-holder kind="3-cols">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'NEW_SUBJECT.PERSONAL_DETAILS.FIRST_NAME' | translate }}</mat-label>
            <input matInput maxlength="250" type="text" formControlName="firstName" readonly autocomplete="off" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'NEW_SUBJECT.PERSONAL_DETAILS.LAST_NAME' | translate }}</mat-label>
            <input matInput type="text" maxlength="250" formControlName="lastName" readonly autocomplete="off" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'NEW_SUBJECT.PERSONAL_DETAILS.PARENT_NAME' | translate }}</mat-label>
            <input matInput type="text" maxlength="250" formControlName="parentName" readonly autocomplete="off" />
          </mat-form-field>
        </field-holder>
        <field-holder kind="3-cols">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'NEW_SUBJECT.PERSONAL_DETAILS.GENDER' | translate }}</mat-label>
            <input matInput type="text" maxlength="250" formControlName="gender" readonly autocomplete="off" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>
              {{ 'NEW_SUBJECT.PERSONAL_DETAILS.DATE_OF_BIRTH' | translate }}
            </mat-label>
            <input matInput [matDatepicker]="dateOfBirth" formControlName="dateOfBirth" readonly disabled
              autocomplete="off" [max]="maxDate" />
            <mat-datepicker-toggle matSuffix [for]="dateOfBirth"></mat-datepicker-toggle>
            <mat-datepicker #dateOfBirth></mat-datepicker>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'NEW_SUBJECT.PERSONAL_DETAILS.JMBG' | translate }}</mat-label>
            <input matInput type="text" maxlength="250" formControlName="jmbg" readonly autocomplete="off" />
          </mat-form-field>
        </field-holder>
        <field-holder kind="2-cols-1-2">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'NEW_SUBJECT.ADDRESS.PHONE' | translate }}</mat-label>
            <input matInput maxlength="250" type="text" formControlName="phone" readonly autocomplete="off" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'NEW_SUBJECT.ADDRESS.ORIGIN_ADDRESS' | translate }}</mat-label>
            <input matInput maxlength="250" type="text" formControlName="permanentResidence" readonly autocomplete="off" />
          </mat-form-field>
        </field-holder>
        <field-holder>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'NEW_SUBJECT.ADDRESS.RESIDENCE_ADDRESS' | translate }}</mat-label>
            <input matInput type="text" maxlength="250" formControlName="residence" readonly autocomplete="off" />
          </mat-form-field>
        </field-holder>
        <field-holder kind="3-cols">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'NEW_SUBJECT.PERSONAL_DETAILS.NATIONALITY' | translate }}</mat-label>
            <input matInput type="text" maxlength="250" formControlName="nationality" readonly autocomplete="off" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'NEW_SUBJECT.PERSONAL_DETAILS.CITIZENSHIP' | translate }}</mat-label>
            <input matInput type="text" maxlength="250" formControlName="citizenship" readonly autocomplete="off" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'NEW_SUBJECT.PERSONAL_DETAILS.NATIVE_LANGUAGE' | translate }}</mat-label>
            <input matInput type="text" maxlength="250" formControlName="language" readonly autocomplete="off" />
          </mat-form-field>
        </field-holder>
        <field-holder kind="2-cols">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'NEW_SUBJECT.PERSONAL_DETAILS.EDUCATION' | translate }}</mat-label>
            <input matInput type="text" maxlength="250" formControlName="education" readonly autocomplete="off" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'NEW_SUBJECT.PERSONAL_DETAILS.EMPLOYMENT' | translate }}</mat-label>
            <input matInput type="text" maxlength="250" formControlName="employment" readonly autocomplete="off" />
          </mat-form-field>
        </field-holder>
        <field-holder kind="2-cols">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'NEW_SUBJECT.PERSONAL_DETAILS.ABLE_TO_WORK' | translate }}</mat-label>
            <input matInput type="text" 
            [value]="firstStep.get('ableToWork')?.value 
            ? ('GLOBAL.YES' | translate) 
            : ('GLOBAL.NO' | translate)" readonly autocomplete="off" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'NEW_SUBJECT.PERSONAL_DETAILS.MARITAL_STATUS' | translate }}</mat-label>
            <input matInput type="text" maxlength="250" formControlName="maritalStatus" readonly autocomplete="off" />
          </mat-form-field>
        </field-holder>
        <form-footer>
          <button matStepperNext mat-stroked-button color="primary" [disabled]="!firstStep.valid"
          class="form-footer__button">
          {{ 'GLOBAL.NEXT_STEP' | translate }}
          </button>
        </form-footer>
      </form>
    </mat-step>
    <mat-step [stepControl]="secondStep">
      <form class="form" [formGroup]="secondStep">
        <ng-template matStepLabel>
          {{ 'SERVICE_PROVIDERS.INTAKE_ASSESSMENT_FORM.STEP_02.TITLE' | translate }}
        </ng-template>
        <table mat-table [dataSource]="contactPersonDataSource" #contactPersonTable class="mb-16"
          *ngIf="contactPersons.length > 0" style="width: -webkit-fill-available">
          
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'SERVICE_PROVIDERS.ASSESSMENT_FORM.STEP_02.CONTACT_PERSON.NAME' | translate}}
            </th>
            <td mat-cell *matCellDef="let element">{{ element.value.name }}</td>
          </ng-container>

          <ng-container matColumnDef="kinship">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'SERVICE_PROVIDERS.ASSESSMENT_FORM.STEP_02.CONTACT_PERSON.KINSHIP' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">{{ element.value.kinship.title }}</td>
          </ng-container>

          <ng-container matColumnDef="address">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'SERVICE_PROVIDERS.ASSESSMENT_FORM.STEP_02.CONTACT_PERSON.ADDRESS' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">{{ element.value.address }}</td>
          </ng-container>

          <ng-container matColumnDef="phone">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'SERVICE_PROVIDERS.ASSESSMENT_FORM.STEP_02.CONTACT_PERSON.PHONE' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">{{ element.value.phone }}</td>
          </ng-container>

          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'SERVICE_PROVIDERS.ASSESSMENT_FORM.STEP_02.CONTACT_PERSON.EMAIL' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">{{ element.value.email }}</td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef></th>
          
            <td mat-cell *matCellDef="let element; let i = index">
          
              <button mat-icon-button class="button-square table__row-button" [matMenuTriggerFor]="menu">
                <mat-icon class="button-square__icon">more_horiz</mat-icon>
              </button>
          
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="editContactPerson(i)">
                  <mat-icon>edit</mat-icon>
                  {{ 'GLOBAL.EDIT' | translate }}
                </button>
                <button mat-menu-item (click)="removeContactPerson(i)">
                  <mat-icon>delete</mat-icon>
                  {{ 'SERVICE_PROVIDERS.CREATE.CONTACT_PERSON.REMOVE_PERSON' | translate }}
                </button> 
              </mat-menu>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedContactColumns"></tr>
          <tr mat-row *matRowDef="let row; let i = index; columns: displayedContactColumns"></tr>
        </table>
        <div class="button-holder">
          <button mat-flat-button color="primary" (click)="addContactPerson()"
            class="form-footer__button form-footer__button--secondary">
            <mat-icon>person_add</mat-icon>
            {{ 'SERVICE_PROVIDERS.CREATE.CONTACT_PERSON.ADD_PERSON' | translate }}
          </button>
        </div>
        <form-footer>
          <button matStepperPrevious mat-stroked-button color="primary"
          class="form-footer__button form-footer__button--secondary">
            {{ 'GLOBAL.PREVIOUS_STEP' | translate }}
          </button>
          <button matStepperNext mat-stroked-button color="primary" class="form-footer__button">
            {{ 'GLOBAL.NEXT_STEP' | translate }}
          </button>
        </form-footer>
      </form>
    </mat-step>
    <mat-step [stepControl]="thirdStep">
      <form class="form" [formGroup]="thirdStep">
        <ng-template matStepLabel>
          {{ 'SERVICE_PROVIDERS.INTAKE_ASSESSMENT_FORM.STEP_03.TITLE' | translate }}
        </ng-template>
        <field-holder>
          <mat-form-field appearance="outline">
            <mat-label>
              {{ 'SERVICE_PROVIDERS.INTAKE_ASSESSMENT_FORM.STEP_03.TITLE'| translate}}
            </mat-label>
            <textarea matInput type="text" formControlName="userAndSignificantOthersExpectations" autocomplete="off"></textarea>
          </mat-form-field>
        </field-holder>
        <form-footer>
          <button matStepperPrevious mat-stroked-button color="primary"
            class="form-footer__button form-footer__button--secondary">
            {{ 'GLOBAL.PREVIOUS_STEP' | translate }}
          </button>
          <button matStepperNext mat-stroked-button color="primary" class="form-footer__button">
            {{ 'GLOBAL.NEXT_STEP' | translate }}
          </button>
        </form-footer>
      </form>
    </mat-step>
    <mat-step [stepControl]="fourthStep">
      <form class="form" [formGroup]="fourthStep">
        <ng-template matStepLabel>
          {{ 'SERVICE_PROVIDERS.INTAKE_ASSESSMENT_FORM.STEP_04.TITLE' | translate }}
        </ng-template>
        <field-holder>
          <mat-form-field appearance="outline">
            <mat-label>
              {{ 'SERVICE_PROVIDERS.INTAKE_ASSESSMENT_FORM.STEP_04.TITLE'| translate}}
            </mat-label>
            <textarea matInput type="text" formControlName="userEligibility" autocomplete="off"></textarea>
          </mat-form-field>
        </field-holder>
        <form-footer>
          <button matStepperPrevious mat-stroked-button color="primary"
            class="form-footer__button form-footer__button--secondary">
            {{ 'GLOBAL.PREVIOUS_STEP' | translate }}
          </button>
          <button matStepperNext mat-stroked-button color="primary" class="form-footer__button">
            {{ 'GLOBAL.NEXT_STEP' | translate }}
          </button>
        </form-footer>
      </form>
    </mat-step>
    <mat-step [stepControl]="fifthStep">
      <form class="form" [formGroup]="fifthStep">
        <ng-template matStepLabel>
          {{ 'SERVICE_PROVIDERS.INTAKE_ASSESSMENT_FORM.STEP_05.TITLE' | translate }}
        </ng-template>
        <field-holder>
          <mat-form-field appearance="outline">
            <mat-label>
              {{ 'SERVICE_PROVIDERS.INTAKE_ASSESSMENT_FORM.STEP_05.TITLE'| translate}}
            </mat-label>
            <textarea matInput type="text" formControlName="serviceProviderCapacity" autocomplete="off"></textarea>
          </mat-form-field>
        </field-holder>
        <form-footer>
          <button matStepperPrevious mat-stroked-button color="primary"
            class="form-footer__button form-footer__button--secondary">
            {{ 'GLOBAL.PREVIOUS_STEP' | translate }}
          </button>
          <button matStepperNext mat-stroked-button color="primary" class="form-footer__button">
            {{ 'GLOBAL.NEXT_STEP' | translate }}
          </button>
        </form-footer>
      </form>
    </mat-step>
    <mat-step [stepControl]="sixthStep">
      <form class="form" [formGroup]="sixthStep">
        <ng-template matStepLabel>
          {{ 'SERVICE_PROVIDERS.INTAKE_ASSESSMENT_FORM.STEP_06.TITLE' | translate }}
        </ng-template>
        <field-holder>
          <mat-form-field appearance="outline">
            <mat-label>
              {{ 'SERVICE_PROVIDERS.INTAKE_ASSESSMENT_FORM.STEP_06.TITLE'| translate}}
            </mat-label>
            <textarea matInput type="text" formControlName="admissionPriority" autocomplete="off"></textarea>
          </mat-form-field>
        </field-holder>
        <form-footer>
          <button matStepperPrevious mat-stroked-button color="primary"
            class="form-footer__button form-footer__button--secondary">
            {{ 'GLOBAL.PREVIOUS_STEP' | translate }}
          </button>
          <button matStepperNext mat-stroked-button color="primary" class="form-footer__button">
            {{ 'GLOBAL.NEXT_STEP' | translate }}
          </button>
        </form-footer>
      </form>
    </mat-step>
    <mat-step [stepControl]="seventhStep">
      <form class="form" [formGroup]="seventhStep">
        <ng-template matStepLabel>
          {{ 'SERVICE_PROVIDERS.INTAKE_ASSESSMENT_FORM.STEP_07.TITLE' | translate }}
        </ng-template>
        <field-holder>
          <mat-form-field appearance="outline">
            <mat-label>
              {{ 'SERVICE_PROVIDERS.INTAKE_ASSESSMENT_FORM.STEP_07.TITLE'| translate}}
            </mat-label>
            <textarea matInput type="text" formControlName="userAbilitiesAndPriorityNeeds" autocomplete="off"></textarea>
          </mat-form-field>
        </field-holder>
        <form-footer>
          <button matStepperPrevious mat-stroked-button color="primary"
            class="form-footer__button form-footer__button--secondary">
            {{ 'GLOBAL.PREVIOUS_STEP' | translate }}
          </button>
          <button matStepperNext mat-stroked-button color="primary" class="form-footer__button">
            {{ 'GLOBAL.NEXT_STEP' | translate }}
          </button>
        </form-footer>
      </form>
    </mat-step>
    <mat-step [stepControl]="eighthStep">
      <form class="form" [formGroup]="eighthStep">
        <ng-template matStepLabel>
          {{ 'SERVICE_PROVIDERS.INTAKE_ASSESSMENT_FORM.STEP_08.TITLE' | translate }}
        </ng-template>
        <field-holder>
          <mat-form-field appearance="outline">
            <mat-label>
              {{ 'SERVICE_PROVIDERS.INTAKE_ASSESSMENT_FORM.STEP_08.TITLE' | translate}}
            </mat-label>
            <textarea matInput type="text" formControlName="alternativeServicesAvailability" autocomplete="off"></textarea>
          </mat-form-field>
        </field-holder>
        <form-footer>
          <button matStepperPrevious mat-stroked-button color="primary"
            class="form-footer__button form-footer__button--secondary">
            {{ 'GLOBAL.PREVIOUS_STEP' | translate }}
          </button>
          <button matStepperNext mat-stroked-button color="primary" class="form-footer__button">
            {{ 'GLOBAL.NEXT_STEP' | translate }}
          </button>
        </form-footer>
      </form>
    </mat-step>
    <mat-step [stepControl]="ninthStep">
      <form class="form" [formGroup]="ninthStep">
        <ng-template matStepLabel>
          {{ 'SERVICE_PROVIDERS.INTAKE_ASSESSMENT_FORM.STEP_09.TITLE' | translate }}
        </ng-template>
        <field-holder>
          <mat-form-field appearance="outline">
            <mat-label>
              {{ 'SERVICE_PROVIDERS.INTAKE_ASSESSMENT_FORM.STEP_09.TITLE' | translate}}
            </mat-label>
            <textarea matInput type="text" formControlName="significantOthersAssessment" autocomplete="off"></textarea>
          </mat-form-field>
        </field-holder>
        <form-footer>
          <button matStepperPrevious mat-stroked-button color="primary"
            class="form-footer__button form-footer__button--secondary">
            {{ 'GLOBAL.PREVIOUS_STEP' | translate }}
          </button>
          <button matStepperNext mat-stroked-button color="primary" class="form-footer__button">
            {{ 'GLOBAL.NEXT_STEP' | translate }}
          </button>
        </form-footer>
      </form>
    </mat-step>
    <mat-step [stepControl]="tenthStep">
      <form class="form" [formGroup]="tenthStep">
          <ng-template matStepLabel>
            {{ 'SERVICE_PROVIDERS.INTAKE_ASSESSMENT_FORM.STEP_10.TITLE' | translate }}
          </ng-template>
          <field-holder>
            <mat-form-field appearance="outline">
              <mat-label>
                {{ 'SERVICE_PROVIDERS.INTAKE_ASSESSMENT_FORM.STEP_10.TITLE'| translate}}
              </mat-label>
              <textarea matInput type="text" formControlName="intakeAssessmentOutcome" autocomplete="off"></textarea>
            </mat-form-field>
          </field-holder>
          <form-footer>
            <button matStepperPrevious mat-stroked-button color="primary"
              class="form-footer__button form-footer__button--secondary">
              {{ 'GLOBAL.PREVIOUS_STEP' | translate }}
            </button>
            <button mat-flat-button mat-stroked-button (click)="preview()" [disabled]="
              (!firstStep.valid ||
              !secondStep.valid ||
              !thirdStep.valid ||
              !fourthStep.valid ||
              !fifthStep.valid ||
              !sixthStep.valid ||
              !seventhStep.valid ||
              !eighthStep.valid ||
              !ninthStep.valid)" class="form-footer__button form-footer__button--secondary">
              {{ 'SERVICE_PROVIDERS.ASSESSMENT_FORM.PREVIEW' | translate }}
            </button>
            <div>
              <button mat-flat-button color="primary" (click)="handleSubmit(); submitButton1.disabled = true;submitButton2.disabled = true;" [disabled]="
                (!firstStep.valid ||
                !secondStep.valid ||
                !thirdStep.valid ||
                !fourthStep.valid ||
                !fifthStep.valid ||
                !sixthStep.valid ||
                !seventhStep.valid ||
                !eighthStep.valid || 
                !ninthStep.valid)" type="button" class="form-footer__button form-footer__button--primary" #submitButton1>
    
                {{ 'SERVICE_PROVIDERS.ASSESSMENT_FORM.GENERATE' | translate }}
              </button>
            </div>
          </form-footer>
      </form>
  </mat-step>
</mat-vertical-stepper>
<button mat-stroked-button color="primary" (click)="closeForm()" type="button"
  class="form-footer__button form-footer__button--secondary">
  {{ 'DIALOG.CANCEL' | translate }}
</button>
<button mat-flat-button color="primary" (click)="save(false); submitButton1.disabled = true;submitButton2.disabled = true;" [disabled]="!firstStep.valid ||
  !secondStep.valid ||
  !thirdStep.valid ||
  !fourthStep.valid ||
  !fifthStep.valid ||
  !sixthStep.valid ||
  !seventhStep.valid ||
  !eighthStep.valid || 
  !ninthStep.valid" class="form-footer__button form-footer__button--secondary" #submitButton2>
  {{ 'SERVICE_PROVIDERS.ASSESSMENT_FORM.SAVE' | translate }}
</button>